/**
 * Génère un ID unique composé d'un préxixe optionel
 */
export const uniqId = (prefix = '_'): string => prefix + Math.random().toString(36).substring(2, 11);
